/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type StartExportRequestSchemaTheme = typeof StartExportRequestSchemaTheme[keyof typeof StartExportRequestSchemaTheme];


export const StartExportRequestSchemaTheme = {
  dark: 'dark',
  light: 'light',
} as const;
